// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:42:06

export default {
  "id": "bubble-shooter-remastered",
  "slug": "bubble-shooter-remastered",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/98c76ae44a02403196becaa895b22755-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/98c76ae44a02403196becaa895b22755/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Bubble Shooter Remastered",
      "description": "Shoot groups of bubbles and form groups to make them pop. Form groups of 3 or more bubbles of the same color to make the bubbles explode.",
      "instructions": "If you just want to relax a bit and like shooting balls, then why not start with the classics. Ball shooting games help relieve stress after a hard day's work, distract from worries and calmly enjoy a pleasant game.",
      "genres": [
        "Bubble Shooter"
      ],
      "tags": [
        "arcade",
        "bubble",
        "classic",
        "colorful",
        "matching"
      ]
    },
    "zh-CN": {
      "title": "泡泡射击大师版",
      "description": "射击成组的气泡，形成组以使其爆炸。形成3个或更多相同颜色的气泡组以使其爆炸。",
      "instructions": "如果你只是想放松一下，又喜欢射击球类，那么为什么不从经典游戏开始呢？射击球类游戏有助于在辛苦工作一天后缓解压力，分散担忧，并平静地享受愉快的游戏。",
      "genres": [
        "泡泡龙"
      ],
      "tags": [
        "街机",
        "泡泡",
        "经典",
        "多彩",
        "配对"
      ]
    },
    "zh-TW": {
      "title": "泡泡射擊精裝版",
      "description": "射擊一群泡泡，形成群組使其爆裂。形成三個或更多同色泡泡的群組，使其爆炸。",
      "instructions": "如果您只是想稍微放鬆一下，又喜歡射擊球，那麼為何不從經典遊戲開始。射擊球遊戲能幫助您在辛苦工作一天後緩解壓力，轉移煩擾，並平靜地享受遊戲樂趣。",
      "genres": [
        "泡泡爆破機"
      ],
      "tags": [
        "電玩",
        "泡泡",
        "經典",
        "色彩豐富",
        "配對"
      ]
    },
    "zh-HK": {
      "title": "泡泡射擊：精裝版",
      "description": "射擊一群泡泡，並形成群組以使其爆破。形成三個或以上同色泡泡的群組，使其爆炸。",
      "instructions": "如果你只想放鬆一點並喜歡射擊球類，那麼為何不從經典遊戲開始呢？射擊球遊戲可幫助在忙碌一天後解壓，分散憂慮並安靜地享受遊戲樂趣。",
      "genres": [
        "泡泡打擊機"
      ],
      "tags": [
        "電玩",
        "泡泡",
        "經典",
        "多顏色",
        "配對"
      ]
    },
    "ja": {
      "title": "バブルシューターレミネイタード",
      "description": "同じ色の泡のグループを3つ以上形成して、それらを爆破する。同じ色の泡のグループを3つ以上形成して、それらを爆破する。",
      "instructions": "少しリラックスしたいだけで、ボールを撃つのが好きなら、どうせならクラシックから始めてみてはいかがでしょうか。ボール撃ちゲームは、一日の終わりにストレスを軽減し、心配事から気を逸らし、穏やかに楽しいゲームを楽しむのに役立ちます。",
      "genres": [
        "バブルシューター"
      ],
      "tags": [
        "アーケード",
        "バブル",
        "クラシック",
        "カラフル",
        "マッチング"
      ]
    },
    "ko": {
      "title": "버블 쏘터 리마스터드",
      "description": "같은 색의 거품을 그룹으로 만들어 터뜨리세요. 같은 색의 거품을 3개 이상으로 그룹을 만들어 터뜨리세요.",
      "instructions": "만약 일상에서 조금의 휴식을 원하시고 공을 쏘는 것을 좋아한다면, 클래식 게임을 시작하는 것은 어떨까요. 공 쏘기 게임은 어려운 하루를 마치고 스트레스를 해소하고, 걱정으로부터 벗어나 안정된 마음으로 즐거운 게임을 즐길 수 있습니다.",
      "genres": [
        "버블 쏘터"
      ],
      "tags": [
        "어거트",
        "발라이어",
        "클래식",
        "컬러풀",
        "매칭"
      ]
    },
    "fr": {
      "title": "Tir de Bulles Révisité",
      "description": "Tirez des groupes de bulles et formez des groupes pour les faire exploser. Formez des groupes de 3 bulles ou plus de la même couleur pour faire exploser les bulles.",
      "instructions": "Si vous souhaitez vous détendre un peu et aimez tirer des balles, pourquoi ne pas commencer par les classiques. Les jeux de tir de balles aident à soulager le stress après une journée de travail difficile, à se détacher des soucis et à savourer calmement un jeu agréable.",
      "genres": [
        "Tir de Bulles"
      ],
      "tags": [
        "arcade",
        "bulle",
        "classique",
        "coloré",
        "correspondance"
      ]
    }
  }
};
